import React from 'react';
import { Color } from '../utils/color';
export var FileIcon = function (_a) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Color.Primary : _d;
    return (React.createElement("svg", { fill: color, className: className, width: width, height: height, viewBox: "0 0 24 24" },
        React.createElement("path", { d: "M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z" })));
};
